var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrimReaper = function SvgGrimReaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.375 15.75 3 7.5M12.772.75l4.557 12M13.466 2.579A6.93 6.93 0 0 1 20.509 1.3l.189.072a.49.49 0 0 1-.047.93c-3.422.922-3.72 1.41-5.795 3.931m5.019 8.017a1.5 1.5 0 0 0-1.5-1.5h-5.25V9.917a4.61 4.61 0 0 0-3.609-4.581A4.5 4.5 0 0 0 4.125 9.75v6a16 16 0 0 1-.618 4.413l-.853 1.768a.749.749 0 0 0 1 .9l2.355-.785a.75.75 0 0 1 .694.072l1.506 1a.75.75 0 0 0 .832 0l1.506-1a.75.75 0 0 1 .694-.072l2.355.785a.749.749 0 0 0 1-.9l-.853-1.768a16 16 0 0 1-.618-4.413h5.25a1.5 1.5 0 0 0 1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.375 10.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0"
  })));
};
export default SvgGrimReaper;